import { render, staticRenderFns } from "./voteTable.vue?vue&type=template&id=5fbd8e39&scoped=true"
import script from "./voteTable.vue?vue&type=script&lang=js"
export * from "./voteTable.vue?vue&type=script&lang=js"
import style0 from "./voteTable.vue?vue&type=style&index=0&id=5fbd8e39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbd8e39",
  null
  
)

export default component.exports